import FormControlLabelComponent from '@mui/material/FormControlLabel'
// import * as S from './styles'

interface IFormControlLabelProps {
  control: React.ReactElement<any, any>
  label: React.ReactNode
}

const FormControlLabel = (props: IFormControlLabelProps) => (
  <FormControlLabelComponent
    data-testid="FormControlLabel"
    control={props.control}
    label={props.label}
  />
)

export { FormControlLabel }
export type { IFormControlLabelProps }
